var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MembersListInner.jinja');
require('./MembersListInner.less');

module.exports = Base.extend({

    template: template,

    events: {

    },

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);
    },


    destroy: function () {

        return Base.prototype.destroy.call(this);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MembersList/MembersListInner.js
// module id = 219
// module chunks = 0